import { FC } from "react";
import { initializeIcons, Stack, Text } from "@fluentui/react";
import { FontSizes } from "@fluentui/react/lib/Styling";
import { colorPallete } from "../../../assets/color";
import "../FunctionalityButtonStack/index.css";
import DraftIcon from "../../../assets/Icons/svg/draftIcon";
import NegotiateIcon from "../../../assets/Icons/svg/negotiateIcon";
import SignIcon from "../../../assets/Icons/svg/signIcon";

interface FunctionalityButtonProps {
  buttonText: string;
  color: string;
  onClickFunction: () => void;
  flex: string;
  icon: string;
}

const styles = {
  headerStyle: {
    fontSize: "1.5rem",
    color: colorPallete.white,
    marginLeft: "0.8vw",
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  iconClass: {
    fontSize: FontSizes.size42,
    color: colorPallete.white,
    margin: "3%",
  },
  headerText: {
    fontSize: "1.25rem",
    lineHeight: 18,
    color: colorPallete.white,
    marginLeft: "1vw",
    fontFamily: "Poppins",
  },
};

initializeIcons();
export const FunctionalityButton: FC<FunctionalityButtonProps> = (props) => {
  function getIcon() {
    if (props.icon === "draft") {
      return <DraftIcon />;
    } else if (props.icon === "negotiate") {
      return <NegotiateIcon />;
    } else if (props.icon === "sign") {
      return <SignIcon />;
    }
  }
  return (
    <Stack
      style={{
        backgroundColor: props.color,
        alignItems: "flex-start",
        flex: props.flex,
        margin: "0% 0.8%",
        borderRadius: "0.4rem",
        justifyContent: "center",
        height: 106,
        boxShadow: "rgba(0, 0, 0, 0.26) 0px 4px 20px 0px",
        alignSelf: "center",
      }}
      className="Button"
      onClick={props.onClickFunction}
    >
      <Stack
        style={{
          display: "flex",
          backgroundColor: "",
          flexDirection: "row",
          alignItems: "center",
          marginLeft: 4,
        }}
      >
        {getIcon()}
        <Text style={styles.headerText}>{props.buttonText.split("-")[0]}</Text>
        <Text style={styles.headerStyle}>{props.buttonText.split("-")[1]}</Text>
      </Stack>
    </Stack>
  );
};
